import { Header } from '../components/home/Header';
import { HeroSection } from '../components/home/HeroSection';
import { FeaturedReaders } from '../components/home/FeaturedReaders';

const images = {
  backgroundImage: 'https://i.postimg.cc/sXdsKGTK/DALL-E-2025-06-06-14-36-29-A-vivid-ethereal-background-image-designed-for-a-psychic-reading-app.webp',
  homePageHeroImage: 'https://i.postimg.cc/tRLSgCPb/HERO-IMAGE-1.jpg',
  founderImage: 'https://i.postimg.cc/s2ds9RtC/FOUNDER.jpg',
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <HeroSection
        backgroundImage={images.backgroundImage}
        heroImage={images.homePageHeroImage}
      />
      <FeaturedReaders />
    </div>
  );
}
